export default function (data: Array<any>) {
  if (typeof window === 'undefined') {
    return
  }

  const queue: Array<any> = (window as any)._learnq || []
  ;(window as any)._learnq = queue

  queue.push(data)
}
